export const getBuyButtonConfig = ({
  entitlements,
  service,
  ctaText,
  ownedCtaText,
  ctaDisabledTooltip = 'productPage.common.buyBox.buttonDisabled.tooltip'
}) => {
  const isBuyEnabled = !entitlements?.has(service);

  return {
    isBuyEnabled,
    ctaText: isBuyEnabled ? ctaText : ownedCtaText || ctaText,
    ownedCtaText,
    ctaDisabledTooltip
  };
};
